import { getApi, postApi } from "./api";

export const GetAllRole = async () => {
    return await getApi(
        `/Role/GetAllRole`
    );
};
export const GetHierarchyRole = async () => {
    return await getApi(
        `/Role/GetRoleHierarchy`
    );
};

export const addRole = async (roleData) => {
    try {
        const response = await postApi(
            "/Role/AdminRole",
            roleData
        );
        return response;

    } catch (error) {

        throw error.response?.data || error.message;
    }
};
export const addChildRole = async (roleChildData) => {
    try {
        const response = await postApi(
            "/Role/ChildRole",
            roleChildData
        );
        return response;

    } catch (error) {

        throw error.response?.data || error.message;
    }
};
export const GetPermissionByRoleId = async (roleId) => {
    return await getApi(
        `/Role/GetPermissionByRoleId/${roleId}`
    );
};
export const GetRolePermissionByRoleId = async (roleId) => {
    return await getApi(
        `/Role/GetRolePermissionByRoleId/${roleId}`
    );
};